import React from 'react'

export type PropsEmptyInputMessage = {
    data: any;
    activate:boolean
}


const EmptyInputMessage = (props: PropsEmptyInputMessage) => {

    if (!props.data && props.activate) {
        return (<small className='error-small'>
            Por favor, complete la información
        </small>)
    }
    else {
        return (<small></small>)
    }

}
export default EmptyInputMessage;
